import type { TextFlashcardsData } from "@/types/storyboard";
import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import ContentBlock from "@/components/storyboard/ContentBlock";
import FlashcardsInlineGrid from "@/components/flashcards/FlashcardsInlineGrid";
import { storyboardTitle } from "@/lib/storyboardTitle";

interface Props {
  title: string;
  contentElementId: string;
  data: TextFlashcardsData;
}

/**
 * Storyboard Lernkarten block — intro, optional instruction, and an in-place
 * flip grid. Sequential review stays in the header study modal.
 */
export const TextFlashcard = ({ title, contentElementId, data }: Props) => {
  const cards = data.cards ?? [];
  const hasIntroduction = data.introduction?.length > 0;
  const instruction = data.instruction?.trim();

  if (cards.length === 0) {
    return null;
  }

  return (
    <ContentBlock title={storyboardTitle(data.title, title)}>
      {hasIntroduction && (
        <div className="prose mb-6 max-w-full text-primary">
          {data.introduction.map((text, index) => (
            <CourseMarkdown key={index}>{text}</CourseMarkdown>
          ))}
        </div>
      )}

      {instruction && (
        <div className="prose mb-6 max-w-full font-bold text-primary/70 prose-p:my-0">
          <CourseMarkdown>{instruction}</CourseMarkdown>
        </div>
      )}

      <FlashcardsInlineGrid
        key={contentElementId}
        contentElementId={contentElementId}
        cards={cards}
      />
    </ContentBlock>
  );
};
